import { Cookies } from 'react-cookie';
import { batch } from 'react-redux';
const emailRegistrationError = 'We\'re sorry, we\'ve encountered an error. Please try again.';
export default function registerLightUserActionCreator(userDuck, personalization, savedInventoryDuck) {
  return _ref => {
    let {
      data = {},
      onBookmarkSaved = () => {},
      onSubscribeUserStart = () => {}
    } = _ref;
    return async (dispatch, getState) => {
      const user = typeof getState().toJS === 'function' ? getState().get('user') : getState().user;
      // get current saved search object
      const savedSearch = userDuck.selectors.getSavedSearch({
        user
      });
      dispatch({
        type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
        payload: 'loading'
      });
      try {
        const {
          keepButtonState = false
        } = data;
        const saveEvent = await personalization.updateEmailSavedSearchItem(data);
        if (saveEvent.status === 200) {
          // create current_user cookies
          const cookies = new Cookies();
          cookies.set('auth_consumer_id', saveEvent.consumerId, {
            path: '/',
            maxAge: 2592000
          });
          // saveEvent.bookmarkSaved always returns false if the user exists as a FULL user.
          switch (saveEvent.bookmarkSaved) {
            case true:
              {
                onBookmarkSaved(data);
                dispatch({
                  type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
                  payload: 'loaded'
                });
                setTimeout(() => {
                  batch(() => {
                    if (!keepButtonState) {
                      dispatch({
                        type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
                        payload: ''
                      });
                    }
                    // Show success message on successful registration
                    dispatch({
                      type: userDuck.types.SHOW_EMAIL_SUBSCRIBE_SUCCESS
                    });
                  });
                }, 2000);
                break;
              }
            // TODO: handle logic for bookmarkSaved fail
            case false:
              {
                if (saveEvent.isOverLimit && !saveEvent.bookmarkAlreadySaved) {
                  batch(() => {
                    dispatch({
                      type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
                      payload: ''
                    });
                    dispatch({
                      type: userDuck.types.SHOW_EMAIL_SUBSCRIBE_FAILURE
                    });
                  });
                  break;
                }
                batch(() => {
                  dispatch({
                    type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
                    payload: ''
                  });
                  dispatch(userDuck.creators.showEmailSubscribeInline(false));
                  dispatch(userDuck.creators.setShowToast(true));
                });
                onSubscribeUserStart(savedSearch);
                break;
              }
            default:
          }
        } else {
          batch(() => {
            dispatch({
              type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
              payload: ''
            });
            // show server error message
            dispatch(userDuck.creators.showLightRegistrationServerError(emailRegistrationError));
          });
        }
        return saveEvent;
      } catch (error) {
        batch(() => {
          dispatch({
            type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
            payload: ''
          });
          dispatch(userDuck.creators.showLightRegistrationServerError(emailRegistrationError));
        });
        throw Error(error);
      }
    };
  };
}